// SwiperStartpage.js
import Swiper from "swiper";
import {
    Navigation,
    Pagination,
    FreeMode
} from "swiper/modules";


class SwiperStartpage {
  constructor() {
    this.swiper = new Swiper('.swiper', {
      modules: [Navigation, Pagination, FreeMode],
      enabled: true,
      momentum: true,
      momentumRatio: 0.6,
      momentumBounce: false,
      sticky: false,
      freeMode: true,
      slidesPerView: 1.2,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
      },
      // Optional:
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
    });
  }
}

export default SwiperStartpage;
